"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PublishedFilterDropdown = void 0;
var _react = _interopRequireWildcard(require("react"));
var React = _react;
var _SelectBoxWrapper = require("../utils/components/SelectBoxWrapper");
var _useTranslations = require("../utils/i18n/useTranslations");
var _alloyReactDropdown = require("@adsk/alloy-react-dropdown");
var _featureFlags = require("../utils/featureFlags");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const BOTH_OPTION_VALUE = "both";
const useFilterOptions = () => {
  const {
    T
  } = (0, _useTranslations.useTranslations)();
  return (0, _react.useMemo)(() => [{
    label: T.translate("filterPanel.publishedOptions.both"),
    // server expects undefined here but client side components disregard undefined values
    value: BOTH_OPTION_VALUE
  }, {
    label: T.translate("filterPanel.publishedOptions.published"),
    value: true
  }, {
    label: T.translate("filterPanel.publishedOptions.unpublished"),
    value: false
  }],
  // eslint-disable-next-line react-hooks/exhaustive-deps
  []);
};
const PublishedFilterDropdown = _ref => {
  let {
    selectedFilter,
    onChange,
    container,
    ...props
  } = _ref;
  const {
    value: shouldUseNewDropdown
  } = (0, _featureFlags.useFeatureFlag)(_featureFlags.FeatureFlag.OutdatedComponentMigrationPhase1Batch2);
  const filterOptions = useFilterOptions();
  const handleChange = React.useCallback(option => {
    onChange(option);
  }, [onChange]);
  const selectedOption = filterOptions.find(option => option.value === selectedFilter);
  const OldDropdown = () => /*#__PURE__*/React.createElement(_SelectBoxWrapper.SelectBoxWrapper, _extends({
    container: container,
    value: selectedOption || filterOptions[0],
    options: filterOptions,
    onChange: handleChange
  }, props));
  const semanticIdentifier = "published-filter-dropdown";
  const NewDropdown = () => {
    const {
      menuProps,
      controlProps
    } = (0, _alloyReactDropdown.useDropdown)({
      items: filterOptions,
      selectedItem: selectedOption || filterOptions[0],
      onSelectedItemChange: _ref2 => {
        let {
          selectedItem
        } = _ref2;
        return handleChange(selectedItem);
      },
      id: semanticIdentifier
    });
    return /*#__PURE__*/React.createElement("div", {
      style: {
        width: "100%"
      }
    }, /*#__PURE__*/React.createElement(_alloyReactDropdown.Control, _extends({}, controlProps, {
      "data-testid": "".concat(semanticIdentifier, "-control")
    })), /*#__PURE__*/React.createElement(_alloyReactDropdown.SingleSelectMenu, _extends({}, menuProps, {
      "data-testid": "".concat(semanticIdentifier, "-menu")
    })));
  };
  return shouldUseNewDropdown ? NewDropdown() : OldDropdown();
};
exports.PublishedFilterDropdown = PublishedFilterDropdown;
//# sourceMappingURL=PublishedFilterDropdown.js.map